export const isTestRunExperimental = (run: Models.IngestConfigApi.RelevanceTests.RelevanceTestRun): boolean => {
    const hasExperimentFlags = run.experimentFlags && Object.keys(run.experimentFlags).length > 0;
    const isNonProdBackend = run.searchBackend && run.searchBackend !== 'prod';

    return Boolean(hasExperimentFlags || isNonProdBackend);
};
